import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useState } from "react";
import commonStyles from "../Common.module.css";
import editStyles from "../Edit.module.css";
import AddressInput from '../inputs/AddressInput';
import StringInput from '../inputs/StringInput';
import SingleLocationDetails from "./SingleLocationDetails";

function AddSingleLocation({ companyId, onUploadStarted, onUploadCanceled, onClose }: IAddSingleLocationProps) {
    const [isLocationUpload, setIsLocationUpload] = useState(false);
    const formik = useFormik<ISingleLocationState>({
        initialValues: SingleLocationState.empty(),
        onSubmit: async () => {
            onUploadStarted();
            setIsLocationUpload(true);
        },
    });

    return (
        !isLocationUpload ? (
            <div>
                <div className={editStyles.column}>
                    <StringInput formik={formik} label="SITE NAME" name="siteName" />
                    <AddressInput formik={formik} label="ADDRESS" name="address" />
                    <StringInput formik={formik} label="NOTES" name="notes" />
                </div>
                <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                    <button className={commonStyles.secondaryButton} onClick={onClose}>Cancel</button>
                    {formik.values.address && (
                        <button type="submit" className={commonStyles.primaryButton} onClick={() => formik.handleSubmit()}>Next</button>
                    )}
                </div>
            </div>
        ) : (
            <SingleLocationDetails
                companyId={companyId}
                state={formik.values}
                onPrevious={() => {
                    setIsLocationUpload(false);
                    onUploadCanceled();
                }}
                onAdd={onClose}
            />
        )
    );
}

interface IAddSingleLocationProps {
    companyId: number;
    onUploadStarted: () => void;
    onUploadCanceled: () => void;
    onClose: () => void;
}

export interface ISingleLocationState {
    siteName: string | null;
    address: string | null;
    notes: string | null;
}

class SingleLocationState implements ISingleLocationState {
    siteName: string | null = null;
    address: string | null = null;
    notes: string | null = null;

    static empty(): SingleLocationState {
        return new SingleLocationState();
    }
}

export default observer(AddSingleLocation);